export default {"src":"/_next/static/media/dog-paw.ca26b81c.svg","height":70,"width":69,"blurWidth":0,"blurHeight":0};